import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Form, Row } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import FormInput from '../../components/forms/formInput';
import { createExpenseType, updateExpenseType } from '../../services/expenseTypes';
import { onMutateSuccess } from '../../utils/queryResponse';
import SbrDrawer from '../../components/sbr/SbrDrawer';

const TagIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg>
);

const SetExpenseTypeModal = ({
    display,
    toggle,
    expenseType,
}) => {

    const { t } = useTranslation();
    const [type, setType] = useState({name: ''})

    const queryClient = useQueryClient()

    const { mutate, isLoading } = useMutation( expenseType ? updateExpenseType : createExpenseType, {
        onSuccess: onMutateSuccess(() => {
            queryClient.invalidateQueries(['expense-types'])
            onHide()
        })
    })

    const onShow = () => {
        expenseType && setType(expenseType)
    }

    const onHide = () => {
        setType({name: ''})
        toggle(false)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        e.stopPropagation()
        mutate(type)
    }

    const handleChange = (objValue) => {
        const newType = { ...type, ...objValue }
        setType(newType)
    }

    return (
        <SbrDrawer
            show={display}
            onHide={onHide}
            onShow={onShow}
            secondary
            title={expenseType ? t('settingsPage.editExpenseTypeTitle') : t('settingsPage.addExpenseTypeTitle')}
            subtitle={t('settingsPage.expenseTypeSubtitle')}
            icon={<TagIcon />}
            footer={
                <>
                    <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={onHide} disabled={isLoading}>{t('common.cancel')}</button>
                    <button type='submit' form="set-expense" className="btn-sbr btn-primary-sbr btn-sm-sbr" disabled={isLoading || expenseType?.name === type.name}>
                        {isLoading ? t('settingsPage.submitting') : t('settingsPage.submit')}
                    </button>
                </>
            }
        >
            <Form id='set-expense' onSubmit={handleSubmit} style={{ position: 'relative' }}>
                <Row className="mb-3">
                    <Col lg="12">
                        <FormInput className="mb-2" label={t('common.name')} value={type.name}
                            onChange={(e) => handleChange({ name: e.target.value })}
                            placeholder={t('settingsPage.enterName')}
                            required
                        />
                    </Col>
                </Row>
            </Form>
        </SbrDrawer>
    )
}

export default SetExpenseTypeModal
